import { API_HOST } from "../BaseUrl";
import client, { headers } from "./config";

export const imageUpload = ({ formData, folderName }) => {
  const updatedHeaders = {
    ...headers,
    "Content-Type": "multipart/form-data",
    folderName,
    company: JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket || "toothlens"
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(API_HOST + `report/image`, formData, {
        headers: updatedHeaders,
      });
      if (response.status === 200) {
        resolve(response);
      }
      reject(response.data);
    } catch (error) {
      reject(error);
    }
  });
};


export const getUploadedImages = () => {
  const folderName = JSON.parse(localStorage.getItem("usertpi")).usertpi;
  const company = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket || "toothlens";

  const updatedHeaders = {
    ...headers,
    "Content-Type": "multipart/form-data",
    company,
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(API_HOST + `read/image`, { imageName: localStorage.getItem("imageName"), folderName }, {
        headers: updatedHeaders,
      });
      if (response.status === 200) {
        resolve(response);
      }
      reject(response.data);
    } catch (error) {
      reject(error);
    }
  });
};


export const whiteningResultImage = () => {
  const folderName = JSON.parse(localStorage.getItem("usertpi")).usertpi;
  const imageName = localStorage.getItem("imageName");
  const company = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket || "toothlens";

  const updatedHeaders = {
    ...headers,
    "Content-Type": "multipart/form-data",
    company,
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(API_HOST + `read/result-image`, { imageName, folderName }, {
        headers: updatedHeaders,
      });
      if (response.status === 200) {
        resolve(response);
      }
      reject(response.data);
    } catch (error) {
      reject(error);
    }
  });
};


export const logData = (data) => {
  const updatedHeaders = {
    ...headers,
    "Content-Type": "application/json",
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(API_HOST + `ping`, data, {
        headers: updatedHeaders,
      });
      if (response.status === 200) {
        resolve(response);
      }
      reject(response.data);
    } catch (error) {
      reject(error);
    }
  });
};


//  write an api to send data to developers
export const sendToDevelopers = (data) => {
  const updatedHeaders = {
    ...headers,
    "Content-Type": "application/json",
  };
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(API_HOST + `send-to-developers`, data, {
        headers: updatedHeaders,
      });
      if (response.status === 200) {
        resolve(response);
      }
      reject(response.data);
    } catch (error) {
      reject(error);
    }
  });
};
